export const SETTING = {
    CURRENCY_SHORT_CODE: 'Rs. ',
    TODAY: new Date().toISOString().split("T")[0],
    MAX_CURRENCY_LENGTH: 10
};


